/**
 * Provides an interface for modifying the list of rules associated with a `Field`.
 * ## Fields
 * Name | Description
 * --- | ---
 * model | The `Field` containing models associated with this view.
 * @module app/views/layer/DataFieldRuleValueEditor
 */
import Backbone from "backbone";
import _ from "underscore";
import DataFieldRuleValueControlEditor from "app/views/layer/DataFieldRuleValueControlEditor";
import ButtonView from "core/views/ButtonView";

export default Backbone.View.extend({
  template: _.template(
    '<div id="divValueRules"><div class="label_block clearfix"><div class="label_block_inner"><div class="col-sm-9 form-group"><label id="value"></label></div><div id="divValueAction" class="field-toggles btn-group btn-group-xs field-top" style="margin-top:0;margin-left: -8px;"></div></div><div><div class="col-sm-9 form-group"><label class="control-label">Visible Fields</label></div><div id="divVisibleFieldAction" class="field-toggles btn-group btn-group-xs field-top" style="margin-top:0;margin-left: -8px;"></div></div><div id="ruleFields"></div></div></div>'
  ),

  initialize: function (options) {
    this.options = options;
    this.model = this.options.model;
    this.rules = this.model.rules;
    this.field = this.options.field;
    this.fields = this.options.fields;
  },

  render: function () {
    var self = this;
    this.$el.html(this.template(_.defaults({}, this.options, {})));
    var $value = this.$("#value");
    var $ruleFields = this.$("#ruleFields");
    var $divValueRules = this.$("#divValueRules");

    var addRule = new ButtonView({
      click: function () {
        self.addNew();
      },
      text: "",
      icon: "plus",
      className: "btn-primary btn-add",
      tooltip: "Add Visible Field",
      attributes: {
        tabindex: "-1",
      },
    });

    var deleteRule = new ButtonView({
      click: function () {
        self.removeValueRules(self.model.value);
      },
      text: "",
      icon: "trash",
      className: "btn-danger",
      tooltip: "Delete Rule",
      attributes: {
        tabindex: "-1",
      },
    });

    this.visibleFields = this.fields.filter(function (field) {
      return (
        field.get("visible") == false && field.get("id") != self.field.get("id")
      );
    });

    addRule.render();
    deleteRule.render();
    this.$("#divVisibleFieldAction").append(addRule.$el);
    this.$("#divValueAction").append(deleteRule.$el);

    $divValueRules[0].setAttribute("id", "divValueRules" + this.model.value);

    $value.html(self.model.text);

    $ruleFields.html("");

    if (self.rules == undefined || self.rules.length <= 0) {
      self.rules = [""];
    }
    _.each(
      self.rules,
      function (model) {
        if (model != undefined) {
          var result = self._appendControls(model);
          $ruleFields.append(result.$el);
        }
      },
      this
    );
  },
  removeValueRules: function (value) {
    var $divRules = this.$("#divValueRules" + value);
    if ($divRules.length > 0) {
      $divRules[0].remove();
      this.field.clearRules(value);
    }
  },
  _appendControls: function (model) {
    var result = new DataFieldRuleValueControlEditor(
      _.extend({
        model: model,
        rules: this.rules,
        value: this.model,
        fields: this.fields,
        field: this.field,
      })
    );
    result.render();
    return result;
  },
  addNew: function () {
    var self = this;
    var $ruleFields = self.$("#ruleFields");
    var result = new DataFieldRuleValueControlEditor(
      _.extend({
        model: "",
        rules: self.rules,
        value: self.model,
        fields: self.fields,
        field: this.field,
      })
    );
    result.render();
    $ruleFields.append(result.$el);
    return false;
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/layer/DataFieldRuleValueEditor.js
// module id = 889
// module chunks = 1